export default "__VITE_ASSET__DnmK5aln__"